import React, { useState } from "react";
import TreeMap from "./TreeMap";
import { getTreeMapSeries } from "../../utils/treeMapSeries";
import BarChart from "./BarChart";
import { getBarChartSeries } from "../../utils/barChartSeries";
import { getTextBoxData } from "../../utils/textBoxData";
//jQuery libraries
import "jquery/dist/jquery.min.js";
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import { mainTableData } from "../../utils/mainTableData";
import { getCrossTableData } from "../../utils/crossTableData";
import "../style.css";

const Landing = (value) => {
  const data = value.data;

  React.useEffect(() => {
    $(document).ready(function () {
      setTimeout(function () {
        $("[name='example_length']").val("100").change();
        $("#example").DataTable();
        $("[name='mainTable_length']").val("100").change();
        $("#mainTable").DataTable();
      }, 1000);
    });
  }, []);

  const [questionNumber, setQuestionNumber] = React.useState(0);
  const [question, setQuestion] = React.useState(null);
  const [questionType, setQuestionType] = React.useState("");
  const [crosstab, setCrossTab] = React.useState({});

  const [crossQuestionNumber, setCrossQuestionNumber] = React.useState(0);
  const [crossQuestion, setCrossQuestion] = React.useState(null);
  const [crossQuestionType, setCrossQuestionType] = React.useState("");

  const [crossTableRow, setCrossTableRow] = React.useState(null);

  const [tableData, setTableData] = React.useState([]);
  const [textBoxData, setTextBoxData] = React.useState([]);
  const [mainData, setMainTableData] = React.useState([]);

  const [cluster, setCluster] = React.useState(null);

  const [crossCluster, setCrossCluster] = React.useState("");
  const [mainCluster, setMainCluster] = React.useState("");

  const onBarChartClick = (value) => {
    // TODO: Implement cluster form
  };

  const questionChange = (num) => {
    setTrSelectedIndex();

    localStorage.setItem("chartMainQuestionNumber", JSON.stringify(num));
    setQuestionNumber(Number(num));

    let targetQuestion = data.main_db.crosstab_questions.find(
      (q) => q.number === Number(num)
    );
    setQuestion(targetQuestion);

    if (targetQuestion.is_closed) {
      setQuestionType("Closed-answer");
    } else if (targetQuestion.is_open) {
      setQuestionType("Open-answer");
    } else if (targetQuestion.is_multi) {
      setQuestionType("Multi-answer");
    }

    let targetCrosstab = data.main_db.crosstabs.find(
      (c) => c.question_row.number === Number(num)
    );
    setCrossTab(targetCrosstab);

    setCluster({
      x: targetQuestion.answers[0].desc,
      y: targetCrosstab.row_totals[0],
    });
    setCrossCluster({ x: targetQuestion.answers[0].desc });
    setMainCluster({ x: targetQuestion.answers[0].desc });
  };

  const crossQuestionChange = (num) => {
    localStorage.setItem("chartCrossQuestionNumber", JSON.stringify(num));
    setCrossQuestionNumber(Number(num));

    let targetCrossQuestion = data.main_db.crosstab_questions.find(
      (q) => q.number === Number(num)
    );
    setCrossQuestion(targetCrossQuestion);

    if (targetCrossQuestion.is_closed) {
      setCrossQuestionType("Closed-answer");
    } else if (targetCrossQuestion.is_open) {
      setCrossQuestionType("Open-answer");
    } else if (targetCrossQuestion.is_multi) {
      setCrossQuestionType("Multi-answer");
    }

    setCrossTableRow(null);
  };

  const setTextTableAnswer = (item) => {
    // TODO: Implement
  };

  const [selectedIndexTreemap, setSelectedIndexTreemap] = useState(1);
  const [trSelectedIndex, setTrSelectedIndex] = useState();

  const changeCrossQ = (value, series, trIndex) => {
    setTrSelectedIndex(trIndex);

    var index = series[0].data.findIndex((e, index) => e.x === value);
    setSelectedIndexTreemap(index);

    var element = document.getElementsByClassName("apexcharts-treemap-rect");

    if (element) {
      for (let i = 0; i < series[0].data.length; i++) {
        element[i]?.classList.remove("first-element");
      }

      element[index]?.classList.add("first-element");
    }

    setCrossCluster({ x: value });
    setTableData(
      getCrossTableData(
        crossQuestionNumber,
        questionNumber,
        data.main_db.crosstabs,
        value
      )
    );
  };

  const onTreeMapClick = (value) => {
    if (value) {
      setCrossCluster({ x: value });
    }

    setTableData(
      getCrossTableData(
        crossQuestionNumber,
        questionNumber,
        data.main_db.crosstabs,
        value
      )
    );
  };

  const [crossTrSelectedIndex, setCrossTrSelectedIndex] = useState();
  const changeMainQ = (value, index) => {
    setCrossTrSelectedIndex(index);
    setMainTableData(
      getCrossTableData(
        questionNumber,
        crossQuestionNumber,
        data.main_db.crosstabs,
        value
      )
    );
    setMainCluster({ x: value });
  };

  React.useEffect(() => {
    if (data) {
      setTableData(
        getCrossTableData(
          crossQuestionNumber,
          questionNumber,
          data.main_db.crosstabs,
          cluster?.x
        )
      );
      setMainTableData(
        getCrossTableData(
          questionNumber,
          crossQuestionNumber,
          data.main_db.crosstabs
        )
      );
    }
  }, [questionNumber, crossQuestionNumber, cluster, data]);

  React.useEffect(() => {
    if (data) {
      let tempTextBoxData = getTextBoxData(
        question,
        crossCluster,
        crossTableRow,
        tableData,
        data.main_db.scalar_datasets,
        data.main_db.one_hot_datasets,
        data.main_db.open_responses,
        data.main_db.id_column
      );
      setTextBoxData(tempTextBoxData);
    }
  }, [question, crossCluster, crossTableRow, tableData, data]);

  React.useEffect(() => {
    const chart_CrossQuestionNumber = JSON.parse(
      localStorage.getItem("chartCrossQuestionNumber")
    );
    if (chart_CrossQuestionNumber && chart_CrossQuestionNumber !== 0) {
      crossQuestionChange(chart_CrossQuestionNumber);
    }

    const chart_MainQuestionNumber = JSON.parse(
      localStorage.getItem("chartMainQuestionNumber")
    );
    if (chart_MainQuestionNumber && chart_MainQuestionNumber !== 0)
      questionChange(chart_MainQuestionNumber);
  }, []);

  if (data) {
    return (
      <>
        <div className="container-fluid">
          <div className="row mr-0 ml-0">
            {/* Main-question */}
            <div className="col-6">
              <h5 style={{ fontSize: "11px" }}>
                Main Question: Dependent variable,
                {questionNumber ? (
                  <span>
                    {questionType === "Closed-answer" && (
                      <span> Closed-ended</span>
                    )}
                    {questionType === "Open-answer" && <span> Open-ended</span>}
                    {questionType === "Multi-answer" && (
                      <span> Multi-ended</span>
                    )}
                  </span>
                ) : null}
              </h5>
              <select
                className="form-control"
                style={{ fontSize: "16px" }}
                value={questionNumber}
                onChange={(e) => questionChange(e.target.value)}
              >
                <option value="0">Select the main question...</option>
                {data.main_db.crosstab_questions.map((item, index) => (
                  <option key={index} value={item.number}>
                    {item.desc}
                  </option>
                ))}
              </select>
            </div>

            {/* Crossed-question */}
            {questionNumber ? (
              <div className="col-6">
                <h5 style={{ fontSize: "11px" }}>
                  Cross Question: Independent variable,
                  {crossQuestionNumber ? (
                    <span>
                      {crossQuestionType === "Closed-answer" && (
                        <span> Closed-ended</span>
                      )}
                      {crossQuestionType === "Open-answer" && (
                        <span> Open-ended</span>
                      )}
                      {crossQuestionType === "Multi-answer" && (
                        <span> Multi-ended</span>
                      )}
                    </span>
                  ) : null}
                </h5>
                <select
                  className="form-control"
                  style={{ fontSize: "16px" }}
                  value={crossQuestionNumber}
                  onChange={(e) => crossQuestionChange(e.target.value)}
                >
                  <option value="0">Select the cross question...</option>
                  {data.main_db.crosstab_questions.map((item, index) => (
                    <option key={index} value={item.number}>
                      {item.desc}
                    </option>
                  ))}
                </select>
              </div>
            ) : null}
          </div>

          <hr className="mt-2 mb-2" />

          {questionNumber ? (
            <div className="main-container">
              <div className="main-contents-header">
                {crossQuestionNumber ? (
                  <>
                    <div className="d-flex">
                      <div className="col-6">
                        <div style={{ fontSize: "12px" }}>
                          <div>
                            Click on table rows to update the Crossed Charts.
                          </div>
                        </div>
                      </div>

                      <div className="col-6">
                        <div style={{ fontSize: "12px" }}>
                          <div>Data crossed with MainQ</div>
                          <div>
                            <strong>Class: </strong>
                            <span>{crossCluster?.x}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr className="mt-0 mb-2" />
                  </>
                ) : null}
              </div>

              {question?.is_closed ? (
                <div className="d-flex align-items-start">
                  {/* 2 table M */}
                  <div className="col-6">
                    <div
                      className="contents-outside"
                      style={{ height: 250, overflowY: "scroll" }}
                    >
                      <table className="table">
                        <thead>
                          <tr>
                            <th scope="col" style={{ width: "0px" }}></th>
                            <th scope="col">Counts</th>
                            <th scope="col">%</th>
                            <th scope="col">Error (%)</th>
                            <th scope="col">Signif</th>
                            <th scope="col">Range (%)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {question.answers.map((item, index) => (
                            <tr
                              className={
                                trSelectedIndex === index
                                  ? "cursor-pointer table_selectedColor"
                                  : "cursor-pointer"
                              }
                              key={index}
                              onClick={() =>
                                changeCrossQ(
                                  item.desc,
                                  getTreeMapSeries(
                                    question.answers,
                                    crosstab.row_totals,
                                    crosstab.grand_total
                                  ),
                                  index
                                )
                              }
                            >
                              <th className="border-right">{item.desc}</th>
                              {mainTableData(
                                data,
                                questionNumber - 1,
                                questionType
                              )["columnDataArray"][index].map(
                                (item1, index1) => (
                                  <td key={index1}>{item1}</td>
                                )
                              )}
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <th style={{ textAlign: "left" }}>Sum</th>
                            {mainTableData(
                              data,
                              questionNumber - 1,
                              questionType
                            )["columnDataArray"][
                              mainTableData(
                                data,
                                questionNumber - 1,
                                questionType
                              )["columnDataArray"].length - 1
                            ].map((item1, index1) => (
                              <>
                                {index1 !== 4 ? (
                                  <td key={index1}>
                                    <strong>{item1}</strong>
                                  </td>
                                ) : (
                                  <td key={index1}>
                                    <strong></strong>
                                  </td>
                                )}
                              </>
                            ))}
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                  {crossQuestionNumber &&
                  tableData.length - crossQuestion.answers.length === 1 ? (
                    <>
                      {/* 4 table */}
                      <div className="col-6">
                        <div
                          className="contents-outside"
                          style={{ height: 250, overflowY: "scroll" }}
                        >
                          <table className="table">
                            <thead>
                              <tr>
                                <th scope="col" style={{ width: "0px" }}></th>
                                <th scope="col">Counts</th>
                                <th scope="col">%</th>
                                <th scope="col">Error (%)</th>
                                <th scope="col">Signif</th>
                                <th scope="col">Range (%)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {crossQuestion.answers.map((item, index) => (
                                <tr
                                  className={
                                    crossTrSelectedIndex === index
                                      ? "cursor-pointer table_selectedColor"
                                      : "cursor-pointer"
                                  }
                                  key={index}
                                  onClick={() => changeMainQ(item.desc, index)}
                                >
                                  <th className="border-right">{item.desc}</th>
                                  {tableData[index].map((item1, index1) => (
                                    <td key={index1}>{item1}</td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                            <tfoot>
                              <tr>
                                <th style={{ textAlign: "left" }}>Sum</th>
                                {tableData[tableData.length - 1].map(
                                  (item1, index1) => (
                                    <td
                                      key={index1}
                                      style={{ textAlign: "center" }}
                                    >
                                      <strong>{item1}</strong>
                                    </td>
                                  )
                                )}
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    </>
                  ) : null}
                </div>
              ) : (
                <div className="row">
                  <div className={question.is_open ? " col-12" : "col-6"}>
                    <div
                      className={
                        question.is_open
                          ? "open-treemap contents-outside ml-3 mr-3"
                          : "multi-treemap contents-outside ml-3"
                      }
                    >
                      <TreeMap
                        key={questionNumber}
                        question={question}
                        onTreeMapClick={onTreeMapClick}
                        series={getTreeMapSeries(
                          question.answers,
                          crosstab.row_totals,
                          crosstab.grand_total,
                          "false"
                        )}
                        grandTotal={crosstab.grand_total}
                        selectedIndex={selectedIndexTreemap}
                      />
                    </div>
                  </div>

                  {question?.is_multi &&
                  crossQuestionNumber &&
                  tableData.length - crossQuestion.answers.length === 1 ? (
                    <div className="col-6">
                      <div
                        className="contents-outside mr-3"
                        style={{ height: 345, overflowY: "scroll" }}
                      >
                        {/* 4 table */}
                        <table className="table">
                          <thead>
                            <tr>
                              <th scope="col" style={{ width: "0px" }}>
                                <div></div>
                              </th>
                              <th scope="col">Counts</th>
                              <th scope="col">%</th>
                              <th scope="col">Error (%)</th>
                              <th scope="col">Signif</th>
                              <th scope="col">Range (%)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {crossQuestion.answers.map((item, index) => (
                              <tr
                                className={
                                  crossTrSelectedIndex === index
                                    ? "cursor-pointer table_selectedColor"
                                    : "cursor-pointer"
                                }
                                key={index}
                                onClick={() => changeMainQ(item.desc, index)}
                              >
                                <th className="border-right">{item.desc}</th>
                                {tableData[index].map((item1, index1) => (
                                  <td key={index1}>{item1}</td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                          <tfoot>
                            <tr>
                              <th style={{ textAlign: "left" }}>Sum</th>
                              {tableData[tableData.length - 1].map(
                                (item1, index1) => (
                                  <td
                                    key={index1}
                                    style={{ textAlign: "center" }}
                                  >
                                    <strong>{item1}</strong>
                                  </td>
                                )
                              )}
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  ) : null}
                </div>
              )}

              <hr className="mt-2 mb-2" />

              <div>
                {/* Closed Question */}
                {question?.is_closed ? (
                  <>
                    <div className="text-center">
                      <strong>Totals Charts</strong>
                    </div>

                    <hr className="mt-2 mb-2" />

                    <div className="d-flex">
                      <div className="col-6">
                        <div className="contents-outside">
                          {/* Bar chart 8 closed */}
                          <BarChart
                            key={questionNumber}
                            onBarChartClick={onBarChartClick}
                            series={
                              mainTableData(
                                data,
                                questionNumber - 1,
                                questionType
                              )["mainSeriesData"]
                            }
                            question={question}
                          />
                        </div>
                      </div>

                      {crossQuestionNumber &&
                      tableData.length - crossQuestion.answers.length === 1 ? (
                        <div className="col-6">
                          <div className="contents-outside">
                            {/* Bar chart 5  */}
                            <BarChart
                              key={crossQuestionNumber}
                              series={
                                mainTableData(
                                  data,
                                  crossQuestionNumber - 1,
                                  questionType
                                )["mainSeriesData"]
                              }
                              question={crossQuestion}
                            />
                          </div>
                        </div>
                      ) : null}
                    </div>
                    {crossQuestionNumber &&
                    tableData.length - crossQuestion.answers.length === 1 ? (
                      <>
                        <hr className="mt-2 mb-1"></hr>
                        <div className="text-center">
                          <strong>Crossed Charts</strong>
                        </div>
                        <hr className="mt-2 mb-1"></hr>
                      </>
                    ) : null}

                    {crossQuestionNumber &&
                    tableData.length - crossQuestion.answers.length === 1 ? (
                      <div className="d-flex mt-3">
                        <div className="col-6">
                          <div className="contents-outside">
                            {/* 7 chart */}
                            <BarChart
                              key={questionNumber}
                              series={getBarChartSeries(
                                crossQuestion,
                                tableData
                              )}
                              plotOptions={true}
                              question={question}
                              cluster={crossCluster}
                              crossQuestion={crossQuestion}
                            />
                          </div>
                        </div>

                        <div className="col-6">
                          <div className="contents-outside">
                            {/* 8 chart */}
                            <BarChart
                              key={crossQuestionNumber}
                              series={getBarChartSeries(question, mainData)}
                              plotOptions={true}
                              question={crossQuestion}
                              cluster={mainCluster}
                              crossQuestion={question}
                            />
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </>
                ) : null}

                <div>
                  {/* Open Question */}
                  {question?.is_open ? (
                    <>
                      <div className="d-flex">
                        <div className="col-6">
                          <div
                            className="contents-outside"
                            style={{ height: 250, overflowY: "scroll" }}
                          >
                            {/* * table */}
                            <table className="table">
                              <thead>
                                <tr>
                                  <th scope="col" style={{ width: "0px" }}></th>
                                  <th scope="col">Counts</th>
                                  <th scope="col">%</th>
                                  <th scope="col">Error (%)</th>
                                  <th scope="col">Signif</th>
                                  <th scope="col">Range (%)</th>
                                </tr>
                              </thead>
                              <tbody>
                                {question.answers.map((item, index) => (
                                  <tr
                                    className={
                                      trSelectedIndex === index
                                        ? "cursor-pointer table_selectedColor"
                                        : "cursor-pointer"
                                    }
                                    key={index}
                                    onClick={() =>
                                      changeCrossQ(
                                        item.desc,
                                        getTreeMapSeries(
                                          question.answers,
                                          crosstab.row_totals,
                                          crosstab.grand_total
                                        ),
                                        index
                                      )
                                    }
                                  >
                                    <th className="border-right">
                                      {item.desc}
                                    </th>
                                    {mainTableData(
                                      data,
                                      questionNumber - 1,
                                      questionType
                                    )["columnDataArray"][index].map(
                                      (item1, index1) => (
                                        <td key={index1}>{item1}</td>
                                      )
                                    )}
                                  </tr>
                                ))}
                              </tbody>
                              <tfoot>
                                <tr>
                                  <th style={{ textAlign: "left" }}>Sum</th>
                                  {mainTableData(
                                    data,
                                    questionNumber - 1,
                                    questionType
                                  )["columnDataArray"][
                                    mainTableData(
                                      data,
                                      questionNumber - 1,
                                      questionType
                                    )["columnDataArray"].length - 1
                                  ].map((item1, index1) => (
                                    <>
                                      {index1 !== 4 ? (
                                        <td key={index1}>
                                          <strong>{item1}</strong>
                                        </td>
                                      ) : (
                                        <td key={index1}>
                                          <strong></strong>
                                        </td>
                                      )}
                                    </>
                                  ))}
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>

                        {crossQuestionNumber &&
                        tableData.length - crossQuestion.answers.length ===
                          1 ? (
                          <div className="col-6">
                            <div
                              className="contents-outside"
                              style={{ height: 250, overflowY: "scroll" }}
                            >
                              {/* 4 table */}
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th scope="col" style={{ width: "0px" }}>
                                      <div></div>
                                    </th>
                                    <th scope="col">Counts</th>
                                    <th scope="col">%</th>
                                    <th scope="col">Error (%)</th>
                                    <th scope="col">Signif</th>
                                    <th scope="col">Range (%)</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {crossQuestion.answers.map((item, index) => (
                                    <tr
                                      className={
                                        crossTrSelectedIndex === index
                                          ? "cursor-pointer table_selectedColor"
                                          : "cursor-pointer"
                                      }
                                      key={index}
                                      onClick={() =>
                                        changeMainQ(item.desc, index)
                                      }
                                    >
                                      <th className="border-right">
                                        {item.desc}
                                      </th>
                                      {tableData[index].map((item1, index1) => (
                                        <td key={index1}>{item1}</td>
                                      ))}
                                    </tr>
                                  ))}
                                </tbody>
                                <tfoot>
                                  <tr>
                                    <th style={{ textAlign: "left" }}>Sum</th>
                                    {tableData[tableData.length - 1].map(
                                      (item1, index1) => (
                                        <td
                                          key={index1}
                                          style={{ textAlign: "center" }}
                                        >
                                          <strong>{item1}</strong>
                                        </td>
                                      )
                                    )}
                                  </tr>
                                </tfoot>
                              </table>
                            </div>
                          </div>
                        ) : null}
                      </div>

                      <hr className="mt-2 mb-1"></hr>
                      <div className="text-center">
                        <strong>Totals Charts</strong>
                      </div>
                      <hr className="mt-2 mb-1"></hr>

                      <div>
                        <div className="d-flex align-items-start">
                          <div className="col-6">
                            <div
                              className="contents-outside border overflow"
                              style={{ height: "355px", fontSize: "14px" }}
                            >
                              <div>
                                {" "}
                                <strong>MainQ: </strong> {question?.desc}{" "}
                              </div>
                              <div className="mb-2">
                                {" "}
                                <strong>Class: </strong> {crossCluster?.x}{" "}
                              </div>

                              {textBoxData.map((item, index) => (
                                <>
                                  {item.interview_number && item.desc && (
                                    <div
                                      className="cursor-pointer cross-interview-desc"
                                      tabIndex={index}
                                      key={index}
                                      onClick={() => setTextTableAnswer(item)}
                                    >
                                      <span className="mr-3">
                                        {item.interview_number}
                                      </span>
                                      {item.desc}
                                    </div>
                                  )}
                                </>
                              ))}
                            </div>
                          </div>

                          <div className="col-6">
                            {crossQuestionNumber &&
                            tableData.length - crossQuestion.answers.length ===
                              1 ? (
                              <div
                                className="contents-outside"
                                style={{ height: "365px" }}
                              >
                                {/* 5 chart */}
                                <BarChart
                                  key={crossQuestionNumber}
                                  series={
                                    mainTableData(
                                      data,
                                      crossQuestionNumber - 1,
                                      questionType
                                    )["mainSeriesData"]
                                  }
                                  question={crossQuestion}
                                />
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      {crossQuestionNumber &&
                      tableData.length - crossQuestion.answers.length === 1 ? (
                        <>
                          <hr className="mt-2 mb-1"></hr>
                          <div className="text-center">
                            <strong>Crossed Charts</strong>
                          </div>
                          <hr className="mt-2 mb-1"></hr>

                          <div className="d-flex">
                            <div className="col-6">
                              <div className="contents-outside">
                                {/* 7 chart */}
                                <BarChart
                                  key={questionNumber}
                                  series={getBarChartSeries(
                                    crossQuestion,
                                    tableData
                                  )}
                                  plotOptions={true}
                                  question={question}
                                  cluster={crossCluster}
                                  crossQuestion={crossQuestion}
                                />
                              </div>
                            </div>

                            {/* 8 chart */}
                            <div className="col-6">
                              <div className="contents-outside">
                                <BarChart
                                  key={crossQuestionNumber}
                                  series={getBarChartSeries(question, mainData)}
                                  plotOptions={true}
                                  question={crossQuestion}
                                  cluster={mainCluster}
                                  crossQuestion={question}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      ) : null}
                    </>
                  ) : null}

                  {/* Multi Question */}
                  {question?.is_multi ? (
                    <div>
                      <hr className="mt-2 mb-1"></hr>
                      <div className="text-center">
                        <strong>Totals Charts</strong>
                      </div>
                      <hr className="mt-2 mb-1"></hr>
                      <div className="d-flex">
                        <div className="col-6">
                          <div
                            className="contents-outside"
                            style={{ height: 315, overflowY: "scroll" }}
                          >
                            <table className="table">
                              <thead>
                                <tr>
                                  <th scope="col" style={{ width: "0px" }}></th>
                                  <th scope="col">Counts</th>
                                  <th scope="col">%</th>
                                  <th scope="col">Error (%)</th>
                                  <th scope="col">Signif</th>
                                  <th scope="col">Range (%)</th>
                                </tr>
                              </thead>
                              <tbody>
                                {question.answers.map((item, index) => (
                                  <tr
                                    className={
                                      trSelectedIndex === index
                                        ? "cursor-pointer table_selectedColor"
                                        : "cursor-pointer"
                                    }
                                    key={index}
                                    onClick={() =>
                                      changeCrossQ(
                                        item.desc,
                                        getTreeMapSeries(
                                          question.answers,
                                          crosstab.row_totals,
                                          crosstab.grand_total
                                        ),
                                        index
                                      )
                                    }
                                  >
                                    <th className="border-right">
                                      {item.desc}
                                    </th>
                                    {mainTableData(
                                      data,
                                      questionNumber - 1,
                                      questionType
                                    )["columnDataArray"][index].map(
                                      (item1, index1) => (
                                        <td key={index1}>{item1}</td>
                                      )
                                    )}
                                  </tr>
                                ))}
                              </tbody>
                              <tfoot>
                                <tr>
                                  <th style={{ textAlign: "left" }}>Sum</th>
                                  {mainTableData(
                                    data,
                                    questionNumber - 1,
                                    questionType
                                  )["columnDataArray"][
                                    mainTableData(
                                      data,
                                      questionNumber - 1,
                                      questionType
                                    )["columnDataArray"].length - 1
                                  ].map((item1, index1) => (
                                    <>
                                      {index1 !== 4 ? (
                                        <td key={index1}>
                                          <strong>{item1}</strong>
                                        </td>
                                      ) : (
                                        <td key={index1}>
                                          <strong></strong>
                                        </td>
                                      )}
                                    </>
                                  ))}
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>

                        {crossQuestionNumber &&
                        tableData.length - crossQuestion.answers.length ===
                          1 ? (
                          <div className="col-6">
                            <div className="contents-outside">
                              {/* 5 chart */}
                              <BarChart
                                key={crossQuestionNumber}
                                series={
                                  mainTableData(
                                    data,
                                    crossQuestionNumber - 1,
                                    questionType
                                  )["mainSeriesData"]
                                }
                                question={crossQuestion}
                              />
                            </div>
                          </div>
                        ) : null}
                      </div>

                      {crossQuestionNumber &&
                      tableData.length - crossQuestion.answers.length === 1 ? (
                        <>
                          <hr className="mt-2 mb-1"></hr>
                          <div className="text-center">
                            <strong>Crossed Charts</strong>
                          </div>
                          <hr className="mt-2 mb-1"></hr>
                        </>
                      ) : null}

                      {question?.is_multi &&
                      crossQuestionNumber &&
                      tableData.length - crossQuestion.answers.length === 1 ? (
                        <div className="d-flex">
                          <div className="col-6">
                            <div className="contents-outside">
                              {/* 7 chart */}
                              <BarChart
                                key={questionNumber}
                                series={getBarChartSeries(
                                  crossQuestion,
                                  tableData
                                )}
                                plotOptions={true}
                                question={question}
                                cluster={crossCluster}
                                crossQuestion={crossQuestion}
                              />
                            </div>
                          </div>

                          <div className="col-6">
                            <div className="contents-outside">
                              {/* 8 chart */}
                              <BarChart
                                key={crossQuestionNumber}
                                series={getBarChartSeries(question, mainData)}
                                plotOptions={true}
                                question={crossQuestion}
                                cluster={mainCluster}
                                crossQuestion={question}
                              />
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </>
    );
  }
};

export default Landing;
